import { createClient } from '@supabase/supabase-js'

// These should be in environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

// Database types will be defined here as the schema is created
export type Database = {
  public: {
    Tables: {
      companies: {
        Row: {
          id: string
          name: string
          created_at: string
        }
        Insert: {
          id?: string
          name: string
          created_at?: string
        }
        Update: {
          id?: string
          name?: string
          created_at?: string
        }
      }
      equipment_v2: {
        Row: {
          id: string
          company_id: string
          name: string
          type: string
          serial_number: string
          wll: number
          last_inspection_date: string | null
          next_inspection_date: string | null
          status: 'active' | 'inactive' | 'retired'
          created_at: string
        }
        Insert: {
          id?: string
          company_id: string
          name: string
          type: string
          serial_number: string
          wll: number
          last_inspection_date?: string | null
          next_inspection_date?: string | null
          status?: 'active' | 'inactive' | 'retired'
          created_at?: string
        }
        Update: {
          id?: string
          company_id?: string
          name?: string
          type?: string
          serial_number?: string
          wll?: number
          last_inspection_date?: string | null
          next_inspection_date?: string | null
          status?: 'active' | 'inactive' | 'retired'
          created_at?: string
        }
      }
      inspections: {
        Row: {
          id: string
          equipment_id: string
          inspector_id: string
          inspection_date: string
          status: 'pass' | 'fail' | 'conditional'
          notes: string | null
          signature: string | null
          created_at: string
        }
        Insert: {
          id?: string
          equipment_id: string
          inspector_id: string
          inspection_date: string
          status: 'pass' | 'fail' | 'conditional'
          notes?: string | null
          signature?: string | null
          created_at?: string
        }
        Update: {
          id?: string
          equipment_id?: string
          inspector_id?: string
          inspection_date?: string
          status?: 'pass' | 'fail' | 'conditional'
          notes?: string | null
          signature?: string | null
          created_at?: string
        }
      }
    }
  }
}

